export const GoogleIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_2447_5614)">
        <path
          d="M20 10.328C20 9.6365 19.9337 8.97161 19.8106 8.33331H10V12.1099H15.6061C15.3598 13.3244 14.6212 14.3528 13.5133 15.0443V17.5H16.8939C18.8636 15.7979 20 13.2979 20 10.328Z"
          fill="currentColor"
        />
        <path
          d="M9.92597 20C12.676 20 14.9815 19.0824 16.6667 17.5094L13.3612 14.9158C12.4537 15.5337 11.2963 15.9083 9.92597 15.9083C7.27782 15.9083 5.02782 14.1011 4.22226 11.6667H0.833374V14.3259C2.5093 17.6873 5.94448 20 9.92597 20Z"
          fill="currentColor"
        />
        <path
          d="M4.16667 11.7664C3.97727 11.2086 3.86536 10.617 3.86536 9.99998C3.86536 9.38301 3.97727 8.79139 4.16667 8.23358V5.83331H1.01584C0.370179 7.08416 0 8.49558 0 9.99998C0 11.5044 0.370179 12.9158 1.01584 14.1666L3.46935 12.2904L4.16667 11.7664Z"
          fill="currentColor"
        />
        <path
          d="M9.88363 4.09652C11.3766 4.09652 12.7038 4.62028 13.7636 5.63038L16.6667 2.68425C14.9064 1.01945 12.6208 0 9.88363 0C5.92068 0 2.5015 2.31014 0.833374 5.67714L4.20648 8.33333C5.00829 5.90161 7.24781 4.09652 9.88363 4.09652Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_2447_5614">
          <rect width="20" height="20" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  )
}
